import React, { useState, useEffect, useRef } from "react";

// const API_URL = "http://10.205.220.67/tamaro_accounting/public/api";
const API_URL = "https://authsat.datame.id/api";
// const REACT_URL = "http://10.205.220.67/tamaro_accounting/public";
const REACT_URL = "https://authsat.datame.id";
const AUTH_URL = "https://authsat.datame.id";

const ENABLE_UAC = true;

export default { API_URL, REACT_URL, AUTH_URL, ENABLE_UAC};
